'use client'

import { useTranslations } from 'next-intl'

export default function MapButtonClient() {
  const t = useTranslations()

  return (
    <button
      onClick={() =>
        window.open(
          'https://www.google.com/maps/d/u/0/edit?mid=1KkZTyT_tQZb0kMylk9YBV5pEI9ZTqpQ&usp=sharing',
          '_blank'
        )
      }
      className='map-button'>
      <svg
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        stroke='#254638'
        className='map-icon hover-icon'>
        <path
          d='M12 6H12.01M9 20L3 17V4L5 5M9 20L15 17M9 20V14M15 17L21 20V7L19 6M15 17V14M15 6.2C15 7.96731 13.5 9.4 12 11C10.5 9.4 9 7.96731 9 6.2C9 4.43269 10.3431 3 12 3C13.6569 3 15 4.43269 15 6.2Z'
          stroke='#254638'
          strokeWidth={2}
          strokeLinecap='round'
          strokeLinejoin='round'></path>
      </svg>
      {t('Work US.WORK_MAP')}
    </button>
  )
}
